<template>
    <p>{{getText}}</p>
</template>
<script>
    export default {
        props: {
            display: { 
                type: Number,
                required: true 
            }
        },
        computed: {
            getText() {
                switch(this.display) {
                    case 0:
                        return this.dataProtectionText;
                        break;
                    case 1:
                        return this.fraudText;
                        break;
                    case 2:
                        return this.declarationText;
                }
            },
            dataProtectionText() {
                return `We may use the personal and business details you give us, or which are 
                    supplied by third parties, to consider your claim and carry out other 
                    enquiries as we may consider necessary to evaluate the claim and assist 
                    in making a decision regarding the claim, and for compliance business 
                    reviews. We may also share these details with other insurance organisations 
                    and selected other parties to handle claims and prevent fraud. Personal 
                    details may be transferred to countries outside of the United Kingdom 
                    or European Economic Area. They will at all times be held securely and 
                    handled with the upmost care in accordance with all principles of the law. 
                    We will store personal details on computer but will not keep them for 
                    longer than necessary, which is usually 7 years for an insurance claim. 
                    For full details of how we process your personal data, including where to 
                    review our privacy notices, please refer to your policy wording.`
            },
            fraudText() {
                return `Deliberately exaggerated claims could invalidate your policy cover.
                    Insurance fraud is a crime and liable to prosecution. The above
                    answers to our questions will be the basis of consideration of your
                    claim. You must ensure that all information is true, correct and
                    complete to the best of your knowledge and belief. In order to
                    prevent and detect fraud we may at any time: • Share information
                    about you with other organisations and public bodies, including the
                    Police. • Check and/or file your details with fraud prevention
                    agencies and databases. • If false or inaccurate information is
                    provided and fraud is identified, details will be passed to fraud
                    prevention agencies. • Law enforcement agencies may access and use
                    this information.`
            },
            declarationText() {
                return `I declare that all information is true, accurate and completed to the
                    best of my knowledge and belief and that all facts have been
                    disclosed. I understand that the information may be checked and passed
                    to other insurance companies or organisations to prevent fraud and I
                    consent to such checks being made and the sharing of my information. I
                    understand that if I make a claim which is false, exaggerated or
                    fraudulent in any way, my claim will not be paid, the insurance will be
                    void with no refund of premium and details of the fraud will be passed
                    to the appropriate authorities for prosecution. If fraud is suspected
                    then details will be passed to the police for further investigation. In
                    the event of my gadget not appearing on the Police Stolen Equipment
                    National Database, I understand that Taurus will register the details.
                    I understand that if my gadget is replaced, the damaged or lost item is
                    no longer my property and ownership will be transferred to Taurus.`
            }
        }
    }
</script>